import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "58",
  height: "40",
  viewBox: "0 0 58 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M50.8936 1.19473C53.3536 1.85325 55.287 3.78646 55.9454 6.24648C57.1354 10.7008 57.1402 20 57.1402 20C57.1402 20 57.1402 29.2992 55.9454 33.7536C55.287 36.2136 53.3536 38.1468 50.8936 38.8052C46.4394 40 28.57 40 28.57 40C28.57 40 10.7008 40 6.24646 38.8052C3.78646 38.1468 1.85325 36.2136 1.19473 33.7536C0 29.2992 0 20 0 20C0 20 0 10.7008 1.19473 6.24648C1.85325 3.78646 3.78646 1.85325 6.24646 1.19473C10.7008 0 28.57 0 28.57 0C28.57 0 46.4394 0 50.8936 1.19473ZM37.6964 20.0008L22.8516 28.5708V11.4307L37.6964 20.0008Z",
      fill: "#FF0000"
    }, null, -1)
  ])))
}
export default { render: render }